import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04e70b9d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=04e70b9d&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=04e70b9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e70b9d",
  null
  
)

export default component.exports